import { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

const CustomCursor = () => {
    const [enabled, setEnabled] = useState(false);
    const [hovering, setHovering] = useState(false);
    const dotX = useMotionValue(-100);
    const dotY = useMotionValue(-100);
    const ringX = useSpring(dotX, { stiffness: 240, damping: 24, mass: 0.6 });
    const ringY = useSpring(dotY, { stiffness: 240, damping: 24, mass: 0.6 });

    useEffect(() => {
        if (window.matchMedia("(pointer: coarse)").matches) return;
        setEnabled(true);
        const move = (e) => {
            dotX.set(e.clientX);
            dotY.set(e.clientY);
            const target = e.target instanceof Element ? e.target : null;
            setHovering(
                !!target?.closest(
                    "a, button, select, input, textarea, label, [role='button']"
                )
            );
        };
        window.addEventListener("mousemove", move);
        return () => window.removeEventListener("mousemove", move);
    }, [dotX, dotY]);

    if (!enabled) return null;

    return (
        <>
            <motion.div
                data-testid="cursor-dot"
                aria-hidden="true"
                className="pointer-events-none fixed left-0 top-0 z-[100] h-1.5 w-1.5 rounded-full bg-brand"
                style={{ x: dotX, y: dotY, translateX: "-50%", translateY: "-50%" }}
            />
            <motion.div
                data-testid="cursor-ring"
                aria-hidden="true"
                className="pointer-events-none fixed left-0 top-0 z-[99] rounded-full border border-brand/40"
                style={{ x: ringX, y: ringY, translateX: "-50%", translateY: "-50%" }}
                animate={{
                    width: hovering ? 46 : 30,
                    height: hovering ? 46 : 30,
                    backgroundColor: hovering
                        ? "rgba(59,130,246,0.08)"
                        : "rgba(59,130,246,0)",
                }}
                transition={{ duration: 0.2, ease: "easeOut" }}
            />
        </>
    );
};

export default CustomCursor;
